if (!customElements.get('collection-filter')) {
    class CollectionFilter extends HTMLElement {
        constructor() {
            super();
            this.filters = [];
        }

        connectedCallback() {
            this.addEventListener('click', event => {
                const inputBox = event.target.closest('input');
                const buttonCollapsable = event.target.closest('button');
                if(buttonCollapsable) {
                    const upperCollapsable = buttonCollapsable.closest('.collection-filter-list');
                    upperCollapsable && upperCollapsable.classList.toggle('active');
                }
                if (!inputBox) return;

                if (inputBox.checked) {
                    // ADD filter
                    if (!this.filters.includes(inputBox.value)) {
                        this.filters.push(inputBox.value);
                    }
                } else {
                    // REMOVE filter
                    this.filters = this.filters.filter(
                        value => value !== inputBox.value
                    );
                }

                // render gamit TANANG active filters
                this.filterPageRender();
            });
        }

        async filterPageRender() {
            const collectionUrl = new URL(window.location.href);

            // build query params
            const params = this.filters.join('&');

            const sectionUrl = `${collectionUrl.pathname}?section_id=main-fit-grid&${params}`;

            const grid = document.getElementById('collection-grid');

            try {
                const response = await fetch(sectionUrl);
                const html = await response.text();

                const parser = new DOMParser();
                const htmlDoc = parser.parseFromString(html, 'text/html');
                const newGrid = htmlDoc.getElementById('collection-grid');

                if (newGrid && grid) {
                    // remove old product items only
                    grid.querySelectorAll('.item').forEach(item => item.remove());

                    // add new product items
                    newGrid.querySelectorAll('.item').forEach(item => {
                        grid.appendChild(item.cloneNode(true));
                    });

                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                    this.updateBrowserURL();
                }
            } catch (error) {
                console.error('Fetch request failed:', error);
            }
        }
        updateBrowserURL() {
            const url = new URL(window.location.href);

            // clear old filter params
            url.search = '';

            // add active filters
            this.filters.forEach(filter => {
                const [key, value] = filter.split('=');
                url.searchParams.append(key, value);
            });

            history.pushState(
                { filters: this.filters },
                '',
                url
            );
        }
    }

    customElements.define('collection-filter', CollectionFilter);
}